import { useState } from "react";

import { useQuery } from "@apollo/client";

import { FETCH_COOKING_HISTORY, GET_FAVOURITE_RECIPES } from "../app/graphql/queries";
import { setUserFavorites } from "../app/homepage/homepage.slice";
import { useAppDispatch, useAppSelector } from "../app/store/hooks";

const usePaginatedCookingSessions = () => {
    const userId = useAppSelector((state) => state.main.user?.id);
    const dispatch = useAppDispatch();
    const [sessions, setSessions] = useState<any[]>([]); // TODO Fix type 
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    // fetching the fav recipes only when cooking-history is initialised. Do we need to fetch when sessions array changes ?
    const { loading: fetchingUserFavs } = useQuery(GET_FAVOURITE_RECIPES, {
        variables: {
            userId
        },
        onCompleted: (data) => {
            if(data?.User_favourite_recipes?.length > 0) {
                const favRecipeIds: string[] = data.User_favourite_recipes.map(
                    (recipe: { recipeId: string }) => recipe.recipeId
                );
                dispatch(setUserFavorites(favRecipeIds));
            }
        }
    })

    const { loading: queryLoading, fetchMore } = useQuery(FETCH_COOKING_HISTORY, {
        variables: {
            _eq: userId,
            _eq1: 'recipe',
            limit: 15,
            offset: 0,
        },
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            if (data?.Sessions_DB?.length === 0) {
                setHasMore(false);
            } else {
                setHasMore(true);
                setSessions([...sessions, ...data.Sessions_DB]);
            }
        },
    });

    const loadMore = () => {
        if (loading || !hasMore) return;
        setLoading(true);

        fetchMore({
            variables: {
                offset: sessions.length,
            },
            updateQuery: (prev, { fetchMoreResult }) => {
                if (!fetchMoreResult?.Sessions_DB.length) {
                    setHasMore(false);
                    return prev;
                }
                setSessions([...sessions, ...fetchMoreResult.Sessions_DB]);
                return {
                    ...prev,
                    Sessions_DB: [...prev.Sessions_DB, ...fetchMoreResult.Sessions_DB],
                };
            }
        }).finally(() => setLoading(false));
    };

    return { sessions, loading: queryLoading || loading, loadMore, hasMore, fetchMore };
};

export default usePaginatedCookingSessions;